import { insuranceInterface } from "./insurance"
export const interfaces = {
  insuranceInterface,
}
